module.exports = __webpack_public_path__ + "img/techcast-grafik_event-innovation.08c7f67.png";